import { useState } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { Asset, kuiperClassNames, TextArea } from '@opallabs/kuiper'
import { doNothing } from '../../helpers/functions/doNothing'
import { Overlay } from '../sharedDisplays/StoryMobileSingle/Overlay'
import { styles } from './styles'

export type Props = {
  accountImage: AssetReference | null
  accountName: string
  allowSharing: boolean
  assets: AssetReference[]
  collabAccount: string
  content: string
  display: string
  instagramCollab: boolean
  isPresenting: boolean
  linkAdCta: string
  linkAdCtaUrl: string
  onExpandAsset?: (id: number) => void
  onRemoveAsset?: (id: number) => void
  postType: string
  readOnly: boolean
  updateCoverAsset?: (value: string, id: number) => void
  updateText?: (value: string, destination: string) => void
}

export const InstagramImageOrVideoStoryAd: React.FC<Props> = ({
  accountImage,
  accountName,
  allowSharing,
  assets,
  collabAccount,
  content,
  display,
  instagramCollab,
  isPresenting = false,
  linkAdCta,
  linkAdCtaUrl,
  onExpandAsset,
  onRemoveAsset,
  postType,
  readOnly = false,
  updateCoverAsset,
  updateText,
}) => {
  const [isHovered, setHovered] = useState(false)

  return (
    <div
      css={styles.containerStyles}
      className={kuiperClassNames(
        `instagram instagram-image-or-video-story-ad instagram-image-or-video-story-ad${display}`
      )}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Overlay
        accountImage={accountImage}
        accountName={accountName}
        allowReplies={false}
        allowSharing={allowSharing}
        collabAccount={collabAccount}
        cta={linkAdCta}
        ctaUrl={linkAdCtaUrl}
        currentIndex={0}
        instagramCollab={instagramCollab}
        modulesLength={1}
        postType={postType}
      />
      {assets && assets[0] && (
        <Asset
          assetReference={assets[0]}
          hasAssetOptions={false}
          preview={false}
          isHovered={isHovered}
          disableMediaControls={false}
          overrideStyles={{
            asset: styles.assetStyle,
            assetBase: styles.assetBaseStyle,
          }}
          hasAssetOverlay={assets[0] && (!readOnly || isPresenting)}
          updateCoverAsset={
            updateCoverAsset && assets[0]
              ? (val: string) => updateCoverAsset(val, assets[0].id || 0)
              : doNothing
          }
          onEmbiggen={
            onExpandAsset && assets[0]
              ? () => onExpandAsset(assets[0].id || 0)
              : doNothing
          }
          onRemove={
            onRemoveAsset && assets[0]
              ? () => onRemoveAsset(assets[0].id || 0)
              : doNothing
          }
        />
      )}
      {!(readOnly && !content) && (
        <div css={styles.contentWrapper}>
          <div
            className={kuiperClassNames('asset-carousel-content-textarea')}
            css={styles.inputWrapperStyle}
          >
            <TextArea
              minRows={1}
              placeholder={isHovered ? 'Add content...' : null}
              value={content}
              style={styles.contentStyle}
              readOnly={readOnly}
              maxRows={4}
              onChange={
                updateText
                  ? (val: string) => updateText(val, 'content')
                  : doNothing
              }
            />
          </div>
        </div>
      )}
    </div>
  )
}
